import { render } from "./terms.vue?vue&type=template&id=4fcabfde&scoped=true&ts=true"
import script from "./terms.vue?vue&type=script&lang=ts"
export * from "./terms.vue?vue&type=script&lang=ts"

import "./terms.vue?vue&type=style&index=0&id=4fcabfde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcabfde"]])

export default __exports__